import React from "react";

import { images } from "../../../config";
import { commonLocalization } from "../../../localization";
import { Text } from "../../styled";

const NoData = ({selectedLanguage}) => {
  const { dataNotAvailable } = commonLocalization[selectedLanguage];

  return (
    <div className="data-not-available">
      <img src={images.dataNotAvailable} alt="data not available" />
      <Text.span>{dataNotAvailable}</Text.span>
    </div>
  );
};

export default NoData;


// WEBPACK FOOTER //
// ./src/components/layouts/noData/noData.js